@import "../../../globalStyles/commons";


:host {
  display: inline-block;
  color: v(--text-primary);
  --checkbox-size: 1rem;
}

.checkbox {
  position: relative;
  display: flex;
  align-items: center;
  @include font-style(body-compact-01);
  cursor: pointer;

  &.has-content {
    gap: v(--spacing-03);
  }


  .input-native {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }

  .box {
    position: relative;
    background: var(--input-background-color, var(--field));
    border: 1px solid v(--icon-primary);
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:before {
      pointer-events: none;
      content: "";
      display: block;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      border-radius: 2px;
      border: 1px solid transparent;
    }
  }

  &.rounded {
    .box {
      border-radius: 50%;

      &:before {
        border-radius: 50%;
      }
    }
  }

  .tick {
    position: absolute;
    width: 0;
    height: 0;
  }

  &.has-focus:not(.active) {
    .box {
      @include focus-ring;
      border-color: transparent;
    }

    &:not(.state-checked) .box:before {
      border-color: v(--icon-01);
    }
  }

  .label {
    color: v(--text-primary);
  }

}

.checkbox.state-checked {
  .box {
    background: v(--icon-primary);
    border-color: transparent;
  }

  .tick {
    width: 33%;
    height: 67%;
    border-right: 2px solid v(--icon-inverse);
    border-bottom: 2px solid v(--icon-inverse);
    transform: rotate(45deg);
    transform-origin: 0 100%;
    top: -15%;
    left: 15%;
  }

  &.active .box {
    border-color: v(--color-white);
  }

  &.has-focus:not(.active) {
    .box {
      @include focus-ring;
      border-color: v(--color-white);
    }
  }

}

.checkbox.state-intermediate {
  .box {
    background: v(--icon-primary);
    border-color: transparent;
  }

  .tick {
    width: 67%;
    height: 0;
    margin: auto;
    border-right: 2px solid v(--icon-inverse);
    border-bottom: 2px solid v(--icon-inverse);
    transform-origin: 0 100%;
  }

  &.active .box {
    border-color: v(--color-white);
  }

  &.has-focus:not(.active) {
    .box {
      @include focus-ring;
      border-color: v(--color-white);
    }
  }

}


/**
 * SIZES
 */
.checkbox.size-md {
  .box {
    width: var(--checkbox-size);
    height: var(--checkbox-size);
  }
}

.checkbox.size-lg {
  .box {
    width: 1.5rem;
    height: 1.5rem;
  }
}


/**
 * States
 */
@each $state in [success, warning, error] {
  :host-context(.input-state-#{$state}) {
    .checkbox .box {
      border-color: v(--color-#{$state});
    }
  }
}

.checkbox.readonly {
  cursor: default;
  color: v(--text-primary) !important;
  border-color: v(--text-disabled) !important;

  &.state-checked .box {
    background: var(--text-disabled) !important;
  }

  .box {
    border: 1px solid var(--text-disabled) !important;
  }

  .tick {
    border-color: var(--disabled-01) !important;
  }

}


.checkbox.disabled {
  cursor: not-allowed;
  color: var(--text-disabled) !important;
  border-color: var(--text-disabled) !important;

  &.state-checked .box {
    background: var(--text-disabled) !important;
  }

  .box {
    border: 1px solid var(--text-disabled) !important;
  }

  .tick {
    border-color: var(--disabled-01) !important;
  }

}


